export const supportsPopover = () =>
  "showPopover" in HTMLElement.prototype &&
  "hidePopover" in HTMLElement.prototype &&
  typeof CSS !== "undefined" &&
  typeof CSS.supports === "function" &&
  CSS.supports("selector(:popover-open)");
